import { ContainerModule } from "inversify";
import {
  type IObterMensagemBoasVindasGateway,
  obterMensagemBoasVindasGatewayDI
} from "../ports/ObterMensagemBoasVindasGateway";
import { ObterMensagemBoasVindasGatewayAdapter } from "../adapters/ObterMensagemBoasVindasGatewayAdapter";
import {
  IObterMensagemBoasVindasUseCase,
  obterMensagemBoasVindasUseCaseDI
} from "../ports/ObterMensagemBoasVindasUseCase";
import { ObterMensagemBoasVindasUseCaseAdapter } from "../adapters/ObterMensagemBoasVindasUseCaseAdapter";

export const primeiroAcessoContabilContainer = new ContainerModule((bind) => {
  bind<IObterMensagemBoasVindasGateway>(obterMensagemBoasVindasGatewayDI).to(
    ObterMensagemBoasVindasGatewayAdapter
  );
  bind<IObterMensagemBoasVindasUseCase>(obterMensagemBoasVindasUseCaseDI).to(
    ObterMensagemBoasVindasUseCaseAdapter
  );
});
